import { render, staticRenderFns } from "./Leaves.vue?vue&type=template&id=7bb66c5a&"
import script from "./Leaves.vue?vue&type=script&lang=js&"
export * from "./Leaves.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports